
import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  TextField,
  MenuItem,
  Button,
  Stack,
} from "@mui/material";
import {
  CheckCircle,
  Email,
  PhoneOutlined,
  ArrowForward,
} from "@mui/icons-material";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    enquiryType: "Course Enquiry",
    requirement: "",
  });
  
  // <Link to="/contact">Contact</Link>

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const newErrors = {};

    if (!form.name.trim()) newErrors.name = "Please enter your name";
    if (!form.email.trim()) {
      newErrors.email = "Please enter your email";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      newErrors.email = "Please enter a valid email";
    }

    if (!form.phone.trim()) newErrors.phone = "Please enter your phone number";
    if (!form.requirement.trim()) {
      newErrors.requirement = "Please describe your requirement";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // Connect your contact/enquiry API here.
      console.log("Contact form data:", form);
      setSubmitted(true);
    }
  };

  const fieldStyles = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      backgroundColor: "#F7F9FC",
      "& fieldset": {
        borderColor: "#DCE3ED",
      },
      "&:hover fieldset": {
        borderColor: "#9BB7E8",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#2864ED",
      },
    },
    "& .MuiInputBase-input": {
      color: "#14213D",
      fontSize: "15px",
      padding: "18px 16px",
    },
    "& .MuiInputLabel-root": {
      color: "#7889A5",
    },
  };

  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 100px)",
        backgroundColor: "#FFFFFF",
        py: { xs: 3, md: 2 },
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            maxWidth: "1290px",
            mx: "auto",
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "0.9fr 1.1fr",
            },
            border: "1px solid #EEF1F6",
            borderRadius: { xs: "18px", md: "24px" },
            overflow: "hidden",
            boxShadow: "0 20px 60px rgba(16, 42, 90, 0.06)",
          }}
        >
          {/* Left information panel */}
          <Box
            sx={{
              position: "relative",
              overflow: "hidden",
              color: "#FFFFFF",
              background:
                "linear-gradient(145deg, #193D7B 0%, #102B63 48%, #122D66 100%)",
              p: { xs: 3, sm: 4, md: 5 },
              display: "flex",
              flexDirection: "column",
              minHeight: { md: "710px" },
            }}
          >
            {/* Background grid */}
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                opacity: 0.08,
                pointerEvents: "none",
                backgroundImage:
                  "linear-gradient(rgba(255,255,255,0.2) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.2) 1px, transparent 1px)",
                backgroundSize: "39px 39px",
              }}
            />

            <Box sx={{ position: "relative", zIndex: 1 }}>
              <Typography
                sx={{
                  color: "#8CC5FF",
                  fontSize: 12,
                  fontWeight: 700,
                  letterSpacing: "1.5px",
                  mb: 2,
                }}
              >
                GET IN TOUCH
              </Typography>

              <Typography
                component="h1"
                sx={{
                  fontSize: { xs: 28, sm: 32, md: 32 },
                  fontWeight: 750,
                  lineHeight: 1.25,
                  letterSpacing: "-0.8px",
                  maxWidth: "390px",
                  mb: 2,
                }}
              >
                Route every inquiry to the right NETLABS workflow.
              </Typography>

              <Typography
                sx={{
                  color: "#D6E3FA",
                  fontSize: 14,
                  lineHeight: 1.8,
                  maxWidth: "390px",
                }}
              >
                Students receive personalized course recommendations.
                Businesses are routed directly into a consultation workflow.
              </Typography>
            </Box>

            <Box sx={{ mt: "auto", pt: { xs: 5, md: 8 }, position: "relative" }}>
              <Stack spacing={1.7} sx={{ mb: 3 }}>
                {[
                  "Reply within one business day",
                  "Free initial consultation",
                  "No spam, ever",
                ].map((item) => (
                  <Stack
                    key={item}
                    direction="row"
                    spacing={1.2}
                    alignItems="center"
                  >
                    <CheckCircle
                      sx={{ color: "#65F0B1", fontSize: 19 }}
                    />
                    <Typography sx={{ fontSize: 13, color: "#E0EAFB" }}>
                      {item}
                    </Typography>
                  </Stack>
                ))}
              </Stack>

              <Box
                sx={{
                  height: "1px",
                  backgroundColor: "rgba(255,255,255,0.15)",
                  mb: 2.3,
                }}
              />

              <Stack spacing={1.5}>
                <Stack direction="row" spacing={1.5} alignItems="center">
                  <Box
                    sx={{
                      width: 36,
                      height: 36,
                      borderRadius: "10px",
                      backgroundColor: "rgba(255,255,255,0.12)",
                      display: "grid",
                      placeItems: "center",
                    }}
                  >
                    <Email sx={{ fontSize: 19 }} />
                  </Box>
                  <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                    info@netlabs.com
                  </Typography>
                </Stack>

                <Stack direction="row" spacing={1.5} alignItems="center">
                  <Box
                    sx={{
                      width: 36,
                      height: 36,
                      borderRadius: "10px",
                      backgroundColor: "rgba(255,255,255,0.12)",
                      display: "grid",
                      placeItems: "center",
                    }}
                  >
                    <PhoneOutlined sx={{ fontSize: 19 }} />
                  </Box>
                  <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                    +91 9876543210
                  </Typography>
                </Stack>
              </Stack>
            </Box>
          </Box>

          {/* Right contact form */}
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{
              backgroundColor: "#FFFFFF",
              p: { xs: 3, sm: 4, md: 5 },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: { xs: 2.2, md: 2.7 },
            }}
          >
            {submitted ? (
              <Box sx={{ textAlign: "center", py: 8 }}>
                <CheckCircle
                  sx={{ color: "#16A36A", fontSize: 54, mb: 2 }}
                />
                <Typography
                  component="h2"
                  sx={{ fontSize: 25, fontWeight: 700, color: "#12254A", mb: 1 }}
                >
                  Thank you for contacting us!
                </Typography>
                <Typography sx={{ color: "#7889A5", mb: 3 }}>
                  Your form has been validated. Connect the enquiry API to send
                  your message to the NetLabs team.
                </Typography>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setSubmitted(false);
                    setForm({
                      name: "",
                      email: "",
                      phone: "",
                      enquiryType: "Course Enquiry",
                      requirement: "",
                    });
                  }}
                >
                  Send another enquiry
                </Button>
              </Box>
            ) : (
              <>
                <TextField
                  name="name"
                  placeholder="Name"
                  value={form.name}
                  onChange={handleChange}
                  error={Boolean(errors.name)}
                  helperText={errors.name}
                  fullWidth
                  sx={fieldStyles}
                />

                <TextField
                  name="email"
                  type="email"
                  placeholder="Email"
                  value={form.email}
                  onChange={handleChange}
                  error={Boolean(errors.email)}
                  helperText={errors.email}
                  fullWidth
                  sx={fieldStyles}
                />

                <TextField
                  name="phone"
                  type="tel"
                  placeholder="Phone"
                  value={form.phone}
                  onChange={handleChange}
                  error={Boolean(errors.phone)}
                  helperText={errors.phone}
                  fullWidth
                  sx={fieldStyles}
                />

                <TextField
                  select
                  name="enquiryType"
                  label="Enquiry Type"
                  value={form.enquiryType}
                  onChange={handleChange}
                  fullWidth
                  sx={fieldStyles}
                >
                  <MenuItem value="Course Enquiry">Course Enquiry</MenuItem>
                  <MenuItem value="Business Enquiry">Business Enquiry</MenuItem>
                  <MenuItem value="IT Services">IT Services</MenuItem>
                  <MenuItem value="Corporate Training">
                    Corporate Training
                  </MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </TextField>

                <TextField
                  name="requirement"
                  placeholder="Requirement"
                  value={form.requirement}
                  onChange={handleChange}
                  error={Boolean(errors.requirement)}
                  helperText={errors.requirement}
                  multiline
                  minRows={3}
                  fullWidth
                  sx={{
                    ...fieldStyles,
                    "& .MuiInputBase-input": {
                      padding: "0",
                      fontSize: "15px",
                    },
                    "& .MuiInputBase-root": {
                      padding: "16px",
                      alignItems: "flex-start",
                    },
                  }}
                />

                <Button
                  type="submit"
                  variant="contained"
                  endIcon={<ArrowForward />}
                  fullWidth
                  sx={{
                    minHeight: 53,
                    borderRadius: "11px",
                    textTransform: "none",
                    fontSize: 15,
                    fontWeight: 700,
                    backgroundColor: "#2864ED",
                    boxShadow: "0 10px 20px rgba(40,100,237,0.2)",
                    "&:hover": {
                      backgroundColor: "#174FCB",
                    },
                  }}
                >
                  Send Message
                </Button>

                <Typography
                  sx={{
                    textAlign: "center",
                    color: "#91A0B9",
                    fontSize: 12,
                    mt: -1.5,
                  }}
                >
                  Your information is used only to respond to this inquiry.
                </Typography>
              </>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
